import React from 'react';

/**
 * Footer — shown on all authenticated internal pages.
 * Login page has its own extended footer with contact info.
 */
const Footer: React.FC = () => {
  return (
    <footer
      style={{
        width: '100%',
        padding: '12px 24px',
        textAlign: 'center',
        fontSize: '12px',
        fontFamily: "'Poppins', sans-serif",
        color: 'var(--color-text-secondary, var(--color-gray-500))',
        borderTop: '1px solid var(--color-border-light, var(--color-gray-200))',
        background: 'var(--color-background-primary, #FFFFFF)',
      }}
    >
      Copyright &copy; 2026 Labhyansh Infotech Private Limited. All rights reserved.
    </footer>
  );
};

export default Footer;
